"use client";
// 상단 지수 박스 장중 스파크라인 — 오늘 분봉 시계열을 미니 영역차트로 표시 (코스피/코스닥/나스닥선물)

import useSWR from "swr";
import { fetcher } from "@/lib/api";

interface IntradayResp {
  data: { points: { t: string; price: number }[] };
}

// symbol: 프론트 지수 심볼, isPositive: 상승 여부(색), strong: 강조(바탕색) 박스 여부,
// enabled: 현재 계좌 종류에서 이 심볼에 스파크라인을 그릴지 (국내/해외에 따라 다름)
export function MarketSparkline({ symbol, isPositive, strong, enabled }: { symbol: string; isPositive: boolean; strong: boolean; enabled: boolean }) {
  const { data } = useSWR<IntradayResp>(
    enabled ? `/api/market/intraday?symbol=${encodeURIComponent(symbol)}` : null,
    fetcher,
    { refreshInterval: 60000 },
  );
  const pts = data?.data?.points || [];
  if (!enabled || pts.length < 2) return null;

  const W = 52, H = 18, PAD = 1;
  const prices = pts.map((p) => p.price);
  const min = Math.min(...prices);
  const max = Math.max(...prices);
  const range = max - min || 1;
  const n = pts.length;
  const px = (i: number) => PAD + (i / (n - 1)) * (W - 2 * PAD);
  const py = (v: number) => PAD + (1 - (v - min) / range) * (H - 2 * PAD);
  const line = prices.map((v, i) => `${i === 0 ? "M" : "L"}${px(i).toFixed(1)},${py(v).toFixed(1)}`).join(" ");
  const area = `${line} L${px(n - 1).toFixed(1)},${H} L${px(0).toFixed(1)},${H} Z`;

  // 강조 바탕(빨강/녹색) 위에서는 흰색 계열, 흰 바탕에서는 상승=빨강/하락=초록
  const stroke = strong ? "rgba(255,255,255,0.95)" : isPositive ? "#ff453a" : "#2faa5c";
  const fill = strong ? "rgba(255,255,255,0.22)" : isPositive ? "rgba(255,69,58,0.12)" : "rgba(47,170,92,0.12)";

  return (
    <svg width={W} height={H} viewBox={`0 0 ${W} ${H}`} className="shrink-0" style={{ display: "block" }} aria-hidden>
      <path d={area} fill={fill} stroke="none" />
      <path d={line} fill="none" stroke={stroke} strokeWidth={1} strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  );
}
